module.exports = __webpack_public_path__ + "r-v3/img/ml_12_00.08db1847.jpg";